/* Explorador de modelos interactivo — Davie Lake View */
(function () {
  'use strict';
  var root = document.getElementById('davie-explorer');
  if (!root) return;

  var tabs   = root.querySelectorAll('.davie-cat-tab');
  var chips  = root.querySelectorAll('.davie-chip-btn');
  var panels = root.querySelectorAll('.davie-panel');

  function activatePanel(index) {
    chips.forEach(function (c) { c.classList.toggle('is-active', c.dataset.index === index); });
    panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.index === index); });
  }

  function selectCategory(cat) {
    tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.cat === cat); });
    var firstIndex = null;
    chips.forEach(function (c) {
      var match = c.dataset.cat === cat;
      c.hidden = !match;
      if (match && firstIndex === null) firstIndex = c.dataset.index;
    });
    if (firstIndex !== null) activatePanel(firstIndex);
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () { selectCategory(t.dataset.cat); });
  });
  chips.forEach(function (c) {
    c.addEventListener('click', function () { activatePanel(c.dataset.index); });
  });

  // Estado inicial
  selectCategory('single');

  /* ---- Lightbox de floor plans ---- */
  var lb = document.getElementById('davie-lightbox');
  if (lb) {
    var lbImg = document.getElementById('davie-lightbox-img');
    var lbCap = document.getElementById('davie-lightbox-cap');
    function openLb(src, name) {
      lbImg.src = src;
      lbImg.alt = 'Floor plan ' + name;
      lbCap.textContent = 'Floor plan · ' + name;
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeLb() { lb.hidden = true; lbImg.src = ''; document.body.style.overflow = ''; }
    document.querySelectorAll('.davie-lightbox-open').forEach(function (b) {
      b.addEventListener('click', function () { openLb(b.getAttribute('data-fp'), b.getAttribute('data-name')); });
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('davie-lightbox__close')) closeLb();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
  }
})();
